/**
 * Filename: 登录公共方法
 * Created Date:2022/10/19
 */

 export default {
    methods: {
        // 获取全部路由，仅root用户使用
        getAllPermission(data){
            this.$store.dispatch('GetPermissionList', {
                tenantId: data.tenantId,
                platform: 'pc'
            }).then(res => {
                this.getUserNav(res)
                // 缓存到session
                this.$sg.ss.set('store', this.$store.state);
            }).catch((err) => {
                console.log(err, 'login')
                this.$message.error(this.$t('message.请联系管理员'))
            })
        },
        /* 获取用户权限 */
        getUserAuths () {
            if (this.$store.state?.userData?.roleGroupId) {
                this.$store.dispatch('GetPermissionList', {
                    roleGroupId: this.$store.state.userData.roleGroupId,
                    platform: 'pc'
                }).then(res => {
                    this.getUserNav(res)
                    // 缓存到session
                    this.$sg.ss.set('store', this.$store.state);
                }).catch((err) => {
                    console.log(err, 'login')
                    this.$message.error(this.$t('message.请联系管理员'))
                })
            } else {
                this.$message.error(this.$t('error.用户信息获取失败'))
                this.$router.push('/login')
            }
        },
        // 获取用户的一级导航
        getUserNav (list) {
            // 获取当前用户的快捷方式
            let params = {
                userId: this.userData.id,
                userType: this.userData.type
            }
            this.$server.getUserConfig(params)
                .then((res) => {
                    if (res.code !== 200) return
                    let userNavigate = res?.data?.navigate ?? []
                    // 筛选pc存在的菜单，去掉pad有但是pc没有的
                    let userRoute = userNavigate.filter(item => {
                        return list.find(val => val.id == item.id);
                    });
                    let data = {
                        route: list,
                        userRoute
                    }
                    this.$store.commit('setMenu', data);
                    this.routeToPage()
                })
        },
        routeToPage () {
            // 筛选开启状态的菜单
            let list = this.$store.state.menuList.filter(item => item.check)
            let result = this.$utils.deepCopy(list)
            // 过滤，只保留一二级菜单
            let menuList = this.filterMenu(result)
            // 菜单第一个
            let firstRoute = menuList[0]
            let route = '/home/index'
            // 二级菜单时，选择二级的第一个
            if (firstRoute.children.length) {
                route = firstRoute.children[0].route
            } else {
                // 一级时，选择第一个
                route = firstRoute.route
            }
            // return;
            this.$router.push({ path: route })
        },
        // 过滤路由，只留菜单
        filterMenu (arr) {
            // 过滤掉不是menu的数据
            return arr.filter(item => {
                if (item.children) {
                    item.children = this.filterMenu(item.children)
                }
                return item.type === 'menu' && !item.hidden
            })
        },
    },
};
